var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderPlusIocn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3332 9.99996C18.3332 14.6023 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6023 1.6665 9.99996C1.6665 5.39759 5.39746 1.66663 9.99984 1.66663C14.6022 1.66663 18.3332 5.39759 18.3332 9.99996ZM9.99985 5.83338C10.4601 5.83338 10.8332 6.20648 10.8332 6.66671V9.16661H13.3333C13.7935 9.16661 14.1666 9.53971 14.1666 9.99995C14.1666 10.4602 13.7935 10.8333 13.3333 10.8333H10.8332V13.3334C10.8332 13.7936 10.4601 14.1667 9.99985 14.1667C9.53961 14.1667 9.16652 13.7936 9.16652 13.3334V10.8333H6.66662C6.20638 10.8333 5.83328 10.4602 5.83328 9.99995C5.83328 9.53971 6.20638 9.16661 6.66662 9.16661H9.16652V6.66671C9.16652 6.20648 9.53961 5.83338 9.99985 5.83338Z",
    fill: "#0050AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderPlusIocn);
export default __webpack_public_path__ + "static/media/headerPlusIocn.bb9a310370c70468ba0aa88bdadf1309.svg";
export { ForwardRef as ReactComponent };